const localPermissions = {
  KEY_ACCOUNT_ACCOUNT_READ_PERMISSION: {
    title: "key_account_account_read_permission",
  },
  KEY_ACCOUNT_PRODUCT_READ_PERMISSION: {
    title: "key_account_product_read_permission",
  },
  KEY_ACCOUNT_PRODUCT_UPDATE_PERMISSION: {
    title: "key_account_product_update_permission",
  },
  KEY_ACCOUNT_PRODUCT_CREATE_REQUEST_PERMISSION: {
    title: "key_account_product_create_request_permission",
  },
  KEY_ACCOUNT_ADD_REPAIR_FILE: {
    title: "key_account_add_repair_file",
  },
  KEY_ACCOUNT_UPDATE_REPAIR_FILE: {
    title: "key_account_update_repair_file",
  },
  KEY_ACCOUNT_CLOSE_REPAIR_FILE: {
    title: "key_account_close_repair_file",
  },
  KEY_ACCOUNT_DELETE_REPAIR_FILE: {
    title: "key_account_delete_repair_file",
  },
  KEY_ACCOUNT_VIEW_ALL_SUMMARY_REPAIR_FILE: {
    title: "key_account_view_all_summary_repair_file",
  },
  KEY_ACCOUNT_VIEW_ATTACHMENT_REPAIR_FILE: {
    title: "key_account_view_attachment_repair_file",
  },
  KEY_ACCOUNT_VIEW_REPAIR_FILE: {
    title: "key_account_view_repair_file",
  },
  KEY_ACCOUNT_PRINT_ATTACHMENT_REPAIR_FILE: {
    title: "key_account_print_attachment_repair_file",
  },
  KEY_ACCOUNT_ADD_ATTACHMENT_REPAIR_FILE: {
    title: "key_account_add_attachment_repair_file",
  },
  KEY_ACCOUNT_COMMENT_REPAIR_FILE: {
    title: "key_account_comment_repair_file",
  },
  KEY_ACCOUNT_EXTRACT_REPAIR_FILE: {
    title: "key_account_extract_repair_file",
  },
  KEY_ACCOUNT_TRANSPORTER_READ_PERMISSION: {
    title: "key_account_transporter_read_permission",
  },
  KEY_ACCOUNT_TRANSPORTER_CREATE_PERMISSION: {
    title: "key_account_transporter_create_permission",
  },
  KEY_ACCOUNT_TRANSPORTER_UPDATE_PERMISSION: {
    title: "key_account_transporter_update_permission",
  },
  KEY_ACCOUNT_TRANSPORTER_DELETE_PERMISSION: {
    title: "key_account_transporter_delete_permission",
  },
};

export default localPermissions;
